import ReducerUtils from "../../utils/ReducerUtils"
import Actions      from "../../model/constant/actions"

export const IsFetched = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVE_ACCOUNTS_FOR_TOKEN] : ()=>true,
})
